<form [formGroup]="form" class="form">
    <h1 mat-dialog-title> Kommentar (optional)</h1>
    <mat-dialog-content>

        <mat-form-field color="primary" appearance="fill">
            <mat-label>Kommentar</mat-label>
            <textarea formControlName="kommentar" matInput #input name="kommentar" id="kommentar" cols="50" rows="10" [maxLength]="maxCharacters"></textarea>      
            <mat-hint align="end"> {{input.value.length || 0 }}/500 </mat-hint>
        </mat-form-field>

    </mat-dialog-content>
    
    <mat-dialog-actions>
        <button class="btn btn-flat bg-gradient-secondary mr-3" (click)="close()"> Abbrechen <i class="fas fa-times"></i></button>
        <button class="btn btn-flat bg-gradient-success" (click)="save()"> Speichern <i class="fas fa-save"></i></button>
    </mat-dialog-actions>
</form>
        